import React, {CSSProperties} from 'react';
import './cancelButtonEditor.scss'

export interface CancelButtonEditorProps {
  className?: string
  style?: CSSProperties
  children?: any
  disabled?: boolean
  onClick?: ()=>void
}

const CancelButtonEditor: React.SFC<CancelButtonEditorProps> = (props) => {
  return (
    <button
      className={`btn button_cancel-editor ${props.className ? props.className : ''}`}
      style={props.style}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
}

export default CancelButtonEditor;
